module.exports = __webpack_public_path__ + "img/bg-score.2f013c2c.png";